import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useEffect, useState, useRef } from 'react';
import { getTrackBackground, Range } from 'react-range';
import { Icon } from 'palette/Icon';
import '../styles/RangeSelect.scss';

const defaultStep = 1;
const defaultSelectedRangeBg = '#000';
const defaultTrackBg = '#bbb';

export function RangeSelect({
    className = '',
    step = defaultStep,
    min = 100,
    max = 1,
    value = [],
    onChange
}) {
    const initialMountRef = useRef(true);
    const [range, setRange] = useState(value);
    const [from, to] = range;

    // Expect value to be always defined
    if (Number.isNaN(from) || Number.isNaN(to)) {
        throw new Error('RangeSelect: value is undefined');
    }

    useEffect(() => {
        if (!initialMountRef.current) {
            setRange([...value]);
        }
    }, [value]);

    useEffect(() => {
        initialMountRef.current = false;
    }, []);

    return (
        <div className={classNames('range-select', className)}>
            <div className="range-select__value-label">
                {from}
                -
                {to}
            </div>
            <Range
                max={max}
                min={min}
                renderThumb={({ props }) => (
                    <div
                        className="range-select__thumb"
                        {...props}
                    >
                        <Icon
                            name="slider_lines"
                            size="xxx-small"
                        />
                    </div>
                )}
                renderTrack={({ props, children }) => (
                    <div
                        className="range-select__track"
                        style={{ ...props.style }}
                    >
                        <div
                            ref={props.ref}
                            style={{
                                height: '2px',
                                width: '100%',
                                background: getTrackBackground({
                                    values: range,
                                    colors: [defaultTrackBg, defaultSelectedRangeBg, defaultTrackBg],
                                    min,
                                    max
                                }),
                                alignSelf: 'center'
                            }}
                        >
                            {children}
                        </div>
                    </div>
                )}
                step={step}
                values={range}
                onChange={setRange}
                onFinalChange={onChange}
            />
        </div>
    );
}

RangeSelect.propTypes = {
    onChange: PropTypes.func.isRequired
};
